import { render } from "./ProfessionalItem.vue?vue&type=template&id=0bbf4ba4"
import script from "./ProfessionalItem.vue?vue&type=script&lang=js"
export * from "./ProfessionalItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__